import React, { useEffect, useState } from "react";
import {
    FaBook,
    FaPen,
    FaClock,
    FaArrowLeft,
    FaFilter,
    FaBookmark,
    FaRegBookmark,
    FaRandom,
    FaChartBar,
    FaSearch,
    FaQuestionCircle,
    FaTrophy,
    FaPlay,
    FaGraduationCap,
    FaFileAlt,
    FaBoxOpen,
    FaUsers,
    FaCalendarAlt,
    FaHourglassHalf,
    FaLock,
    FaCheckCircle,
    FaBookOpen,
    FaCalendarTimes,
    FaTimesCircle
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../config/apiConfig";
import { useQuiz } from "../../utils/api/Redux/QuizContext";
import { ClipLoader } from "react-spinners";
import AnimatedNumber from "../../components/counterAnimation";
import toast, { Toaster } from "react-hot-toast";
import { jwtDecode } from "jwt-decode";

const SingleSubjectQuizFree = () => {
    const [quizData, setLocalQuizData] = useState([]);
    const [filters, setFilters] = useState({});
    const [mode, setMode] = useState("");
    const [timeLeft, setTimeLeft] = useState(6300); // 1h 45m
    const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
    const [selectedTopic, setSelectedTopic] = useState("");
    const [selectedDifficulty, setSelectedDifficulty] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [bookmarkedQuestions, setBookmarkedQuestions] = useState(new Set());
    const [showAnalytics, setShowAnalytics] = useState(false);
    const [userProgress, setUserProgress] = useState({});
    const { setQuizData } = useQuiz();
    const [incompleteTests, setIncompleteTests] = useState([]);
    const [allQuestions, setAllQuestions] = useState([]);
    const [exams, setExams] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const isFreeUser = true
    const [isLoading, setIsLoading] = useState(false);
    // Keep a single state declaration at the top
    const [subjectStats, setSubjectStats] = useState({
        total: 0,
        topics: {},
        difficulty: {}
    });

    const navigate = useNavigate();
    const token = localStorage.getItem("token");
    const user = jwtDecode(token)
    const user_id = user?.user_id;
    const params = new URLSearchParams(window.location.search);
    // const [subjectStats, setSubjectStats] = useState({ topics: {}, difficulty: {} });
    const subject = params.get("subject");

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, []); // runs only on mount





    // Load user progress from localStorage
    useEffect(() => {
        const savedProgress = localStorage.getItem(`progress_${subject}_${user_id}`);
        if (savedProgress) {
            setUserProgress(JSON.parse(savedProgress));
        }
    }, [subject, user_id]);





    // Fetch questions
    useEffect(() => {
        const fetchQuestions = async () => {
            setIsLoading(true);
            try {
                const response = await fetch(`${API_BASE_URL}/api/quiz/subjects-free/${subject}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${localStorage.getItem("token")}`
                    },
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || "Failed to fetch questions");
                }

                const data = await response.json();
                console.log(data)
                setAllQuestions(data?.questions)
                setLocalQuizData(data?.questions);
            } catch (error) {
                console.error("Error fetching questions:", error.message);
                toast.error(error.message)
            } finally {
                setIsLoading(false);
            }
        };

        fetchQuestions();
    }, [subject]);

    // Calculate stats once both localQuizData and incompleteTests are ready
    useEffect(() => {
        if (allQuestions?.length > 0) {
            calculateSubjectStats(incompleteTests, allQuestions);
        }

    }, [allQuestions, incompleteTests]);

    const calculateSubjectStats = (incompleteTests, questions) => {
        const topicStats = {};
        const difficultyStats = { Easy: 0, Medium: 0, Hard: 0 };

        // Flatten all answers
        const allAnswers = incompleteTests.flatMap(test => test.answers);

        // Build answered lookup
        const answeredLookup = {};
        allAnswers.forEach(ans => {
            answeredLookup[ans.question_id] = {
                selected_option: ans.selected_option,
                correct: ans.is_correct === 1
            };
        });

        // Loop over all questions for this subject to get total counts
        questions.forEach(q => {
            // Initialize topic
            if (!topicStats[q.topic]) {
                topicStats[q.topic] = { total: 0, completed: 0, correct: 0, incorrect: 0 };
            }

            topicStats[q.topic].total++;

            // Check if answered
            const progress = answeredLookup[q.id];
            if (progress) {
                topicStats[q.topic].completed++;
                if (progress.correct) topicStats[q.topic].correct++;
                else topicStats[q.topic].incorrect++;
            }

            // Difficulty
            if (difficultyStats.hasOwnProperty(q.level)) {
                difficultyStats[q.level]++;
            }
        });

        setSubjectStats({
            total: questions?.length,
            topics: topicStats,
            difficulty: difficultyStats
        });
    };

    const continueQuiz = async (test, quizMode) => {
        if (!test) return;
        // Preserve the test's original mode so resumed answers are saved with the
        // same mode they started with. Without this, the teacher's analysis
        // endpoint (which filters mode = "exam") drops every answer the student
        // gives in the resumed session.
        const resolvedMode = quizMode || test.answers?.[0]?.mode || "exam";
        console.log(test)

        // Already answered questions (keep order as is)
        const answeredQuestions = test.answers.map(ans => ({
            ...ans.quiz,
            selectedOption: ans.selected_option,
        }));

        // Remaining questions from the question bank that haven't been answered
        const allQuestionBank = getFilteredQuestions();
        let unansweredQuestions = allQuestionBank.filter(
            (q) => !answeredQuestions.some(a => a.id === q.id)
        );

        // Apply mode-specific slicing/shuffling only on unanswered questions
        if (resolvedMode === "exam") {
            unansweredQuestions = unansweredQuestions.sort(() => Math.random() - 0.5).slice(0, 40 - answeredQuestions?.length);
        } else if (resolvedMode === "study") {
            if (selectedTopic) {
                unansweredQuestions = unansweredQuestions.slice(0, 20 - answeredQuestions?.length);
            } else {
                unansweredQuestions = unansweredQuestions.sort(() => Math.random() - 0.5).slice(0, 20 - answeredQuestions?.length);
            }
        } else if (resolvedMode === "random") {
            unansweredQuestions = unansweredQuestions.sort(() => Math.random() - 0.5).slice(0, 10 - answeredQuestions?.length);
        }

        // Merge answered first, then unanswered
        const selectedQuestions = [...answeredQuestions, ...unansweredQuestions];

        // Set quiz data
        setQuizData(selectedQuestions);

        // Navigate to exam page with previous answers prefilled
        navigate("/exam-free", {
            state: {
                test_id: test.test_id,
                mode: resolvedMode,
                subject: subject,
                previousAnswers: answeredQuestions.map(ans => ({
                    question_id: ans.id,
                    selected_option: ans.selected_option,
                })),
            },
        });
    };


    const getFilteredQuestions = () => {
        let filtered = [...quizData];

        // Topic filter
        if (selectedTopic) {
            filtered = filtered.filter(q => q.topic === selectedTopic);
        }

        // Difficulty filter
        if (selectedDifficulty) {
            filtered = filtered.filter(q => q.level === selectedDifficulty);
        }

        // Search filter
        if (searchTerm) {
            filtered = filtered.filter(q =>
                q.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
                q.topic.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        return filtered;
    };

    const startQuiz = async (quizMode = mode, customQuestions = null) => {
        if (!quizMode) return;

        let selectedQuestions = customQuestions || getFilteredQuestions();

        // Apply mode-specific logic
        if (quizMode === "exam") {
            selectedQuestions = selectedQuestions.sort(() => Math.random() - 0.5).slice(0, 40);
        } else if (quizMode === "study") {
            if (selectedTopic) {
                selectedQuestions = selectedQuestions.slice(0, 20);
            } else {
                selectedQuestions = selectedQuestions.sort(() => Math.random() - 0.5).slice(0, 20);
            }
        } else if (quizMode === "random") {
            selectedQuestions = selectedQuestions.sort(() => Math.random() - 0.5).slice(0, 10);
        }

        setQuizData(selectedQuestions);
        const testId = await createTest();

        if (testId) {
            navigate("/exam-free", {
                state: {
                    test_id: testId,
                    time_left: timeLeft,
                    mode: quizMode,
                    subject: subject
                }
            });
        }
    };

    const createTest = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/tests-free`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem("token")}`
                },
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || "Failed to create test");
            }

            const test = await response.json();
            localStorage.setItem('test_id', test.data.id);
            return test.data.id;
        } catch (error) {
            console.error("Error creating test:", error.message);
            return null;
        }
    };

    const goBack = () => {
        navigate(-1);
    };

    // Get unique values for filters
    const uniqueTopics = [...new Set(quizData?.map(q => q.topic))];
    const uniqueLevels = [...new Set(quizData?.map(q => q.level))];

    const [timeLefts, setTimeLefts] = useState({}); // store countdown per exam

    useEffect(() => {
        const timers = setInterval(() => {
            setTimeLefts(prev => {
                const newTimes = {};
                exams.forEach(exam => {
                    const start = new Date(exam.startTime);
                    const now = new Date();
                    newTimes[exam.exam_id] = Math.max(0, Math.floor((start - now) / 1000));
                });
                return newTimes;
            });
        }, 1000);

        return () => clearInterval(timers);
    }, [exams]);

    if (isLoading) {
        return (
            <div className="flex items-center justify-center h-screen bg-gray-100">
                <ClipLoader color="#4A90E2" size={50} />
                <p className="ml-4 text-blue-600 font-medium">Loading {subject} questions...</p>
            </div>
        );
    }




    return (
        <div className="min-h-screen bg-gray-50">
            {/* Header with Back Button */}
            <div className="bg-white shadow-sm">
                <div className="max-w-6xl mx-auto px-6 py-4">
                    <button
                        onClick={goBack}
                        className="flex items-center gap-2 text-[#2148C0] hover:text-blue-600 font-medium transition-colors"
                    >
                        <FaArrowLeft className="text-lg" />
                        Back to Subjects
                    </button>
                </div>
            </div>

            {/* Toaster */}
            <Toaster position="top-right" reverseOrder={false} />

            <div className="max-w-6xl mx-auto px-6 py-8">
                {/* Subject Header */}
                <div className="text-center mb-4">
                    <h1 className="text-4xl font-bold text-[#2148C0] mb-3">
                        {subject} Practice
                    </h1>

                    {/* Free Account Notice */}
                    {isFreeUser && (
                        <div className="bg-yellow-100 border-l-4 border-yellow-400 text-yellow-700 px-4 py-2 mb-6 text-sm md:text-base rounded">
                            Note: Free accounts can only attempt up to <span className="font-semibold">{subjectStats?.total} questions for this subject </span>.
                            Upgrade to a subscription for full access.
                        </div>
                    )}

                    <div className="flex justify-center items-center gap-6 text-gray-600">
                        <span className="flex items-center gap-1">
                            Topics: <AnimatedNumber value={Object.keys(subjectStats?.topics || {})?.length} />
                        </span>
                    </div>
                </div>

                {/* Quick Stats Cards */}
                {/* Quick Stats Cards */}
                <div className="grid grid-cols-3 lg:grid-cols-3 gap-4 mb-8">

                    <div className="bg-white p-6 rounded-xl shadow-sm border border-green-100">
                        <div className="flex items-center justify-between mb-3">
                            <FaTrophy className="text-2xl text-green-600" />
                            <span className="text-2xl font-bold text-green-600">
                                {Object.values(subjectStats?.topics || {}).reduce(
                                    (total, topic) => total + (topic.completed || 0),
                                    0
                                )}
                            </span>
                        </div>
                        <h3 className="font-semibold text-gray-700">Completed</h3>
                    </div>

                    <div className="bg-white p-6 rounded-xl shadow-sm border border-yellow-100">
                        <div className="flex items-center justify-between mb-3">
                            <FaBookmark className="text-2xl text-yellow-600" />
                            <span className="text-2xl font-bold text-yellow-600">
                                <AnimatedNumber value={bookmarkedQuestions.size} />
                            </span>
                        </div>
                        <h3 className="font-semibold text-gray-700">Bookmarked</h3>
                    </div>

                    <div className="bg-white p-6 rounded-xl shadow-sm border border-purple-100">
                        <div className="flex items-center justify-between mb-3">
                            <FaQuestionCircle className="text-2xl text-purple-600" />
                            <span className="text-2xl font-bold text-purple-600">
                                <AnimatedNumber value={uniqueTopics?.length} />
                            </span>
                        </div>
                        <h3 className="font-semibold text-gray-700">Topics</h3>
                    </div>
                </div>


                {/* Practice Modes */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                    <div className="bg-gradient-to-br from-blue-500 to-blue-700 text-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                        <div className="flex items-center mb-4">
                            <div className="bg-white bg-opacity-20 p-3 rounded-lg mr-4">
                                <FaPen className="text-2xl" />
                            </div>
                            <h3 className="text-xl font-bold">Exam Mock</h3>
                        </div>
                        <p className="mb-6 text-blue-100 leading-relaxed">
                            Full exam simulation with {subjectStats?.total} random questions under timed conditions.
                        </p>
                        <button
                            onClick={() => startQuiz("exam")}
                            disabled={quizData?.length === 0}
                            className="w-full bg-white text-blue-600 py-3 px-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            Start Exam Mock
                        </button>
                    </div>

                    <div className="bg-gradient-to-br from-green-500 to-green-700 text-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                        <div className="flex items-center mb-4">
                            <div className="bg-white bg-opacity-20 p-3 rounded-lg mr-4">
                                <FaBook className="text-2xl" />
                            </div>
                            <h3 className="text-xl font-bold">Study Mode</h3>
                        </div>
                        <p className="mb-6 text-green-100 leading-relaxed">
                            Practice with filtered questions, see explanations, and track progress.
                        </p>
                        <button
                            onClick={() => startQuiz("study")}
                            disabled={quizData?.length === 0}
                            className="w-full bg-white text-green-600 py-3 px-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            Start Studying
                        </button>
                    </div>

                    <div className="bg-gradient-to-br from-purple-500 to-purple-700 text-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                        <div className="flex items-center mb-4">
                            <div className="bg-white bg-opacity-20 p-3 rounded-lg mr-4">
                                <FaRandom className="text-2xl" />
                            </div>
                            <h3 className="text-xl font-bold">Random Practice</h3>
                        </div>
                        <p className="mb-6 text-purple-100 leading-relaxed">
                            Quick practice with 10 random questions for variety and revision.
                        </p>
                        <button
                            onClick={() => startQuiz("random")}
                            disabled={quizData?.length === 0}
                            className="w-full bg-white text-purple-600 py-3 px-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            Random Practice
                        </button>
                    </div>
                </div>

                {/* Timer Settings for Exam Mode */}
                {mode === "exam" && (
                    <div className="bg-white rounded-xl shadow-sm p-6 mb-8">
                        <div className="flex items-center mb-4">
                            <FaClock className="text-blue-600 text-2xl mr-3" />
                            <h3 className="text-xl font-semibold text-gray-800">Exam Timer Settings</h3>
                        </div>
                        <div className="flex items-center gap-6">
                            <div className="flex items-center gap-3">
                                <label className="font-medium text-gray-700">Hours:</label>
                                <input
                                    type="number"
                                    min="0"
                                    max="3"
                                    value={Math.floor(timeLeft / 3600)}
                                    onChange={(e) => {
                                        const hours = parseInt(e.target.value, 10) || 0;
                                        setTimeLeft(hours * 3600 + (timeLeft % 3600));
                                    }}
                                    className="w-20 p-3 border border-gray-200 rounded-lg text-center focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                />
                            </div>
                            <div className="flex items-center gap-3">
                                <label className="font-medium text-gray-700">Minutes:</label>
                                <input
                                    type="number"
                                    min="0"
                                    max="59"
                                    value={Math.floor((timeLeft % 3600) / 60)}
                                    onChange={(e) => {
                                        const minutes = parseInt(e.target.value, 10) || 0;
                                        setTimeLeft(Math.floor(timeLeft / 3600) * 3600 + minutes * 60);
                                    }}
                                    className="w-20 p-3 border border-gray-200 rounded-lg text-center focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                />
                            </div>
                        </div>
                    </div>
                )}


                {/* Incomplete Tests */}
                {incompleteTests?.length > 0 && (
                    <div className="bg-white rounded-xl shadow-sm p-6">
                        <h2 className="text-xl font-semibold text-gray-800 mb-6 flex items-center gap-2">
                            <FaClock className="text-orange-500" />
                            Continue Where You Left Off
                        </h2>
                        <div className="space-y-4">
                            {incompleteTests.map((test, index) => {
                                const totalQuestions = 20;
                                const answered = test.answers?.length;
                                const progress = Math.min((answered / totalQuestions) * 100, 100);

                                return (
                                    <div
                                        key={test.test_id}
                                        className="flex flex-col lg:flex-row items-start lg:items-center justify-between bg-orange-50 p-6 rounded-lg border border-orange-200"
                                    >
                                        <div className="flex-1 w-full lg:mr-6">
                                            <h3 className="font-semibold text-gray-800 mb-2">
                                                Incomplete Test #{index + 1}
                                            </h3>
                                            <p className="text-sm text-gray-600 mb-3">
                                                {answered} of {totalQuestions} questions answered
                                            </p>
                                            <div className="w-full bg-gray-200 rounded-full h-3">
                                                <div
                                                    className="bg-gradient-to-r from-orange-400 to-orange-600 h-3 rounded-full transition-all duration-500"
                                                    style={{ width: `${progress}%` }}
                                                ></div>
                                            </div>
                                        </div>
                                        <button
                                            onClick={() => continueQuiz(test)}
                                            className="mt-4 lg:mt-0 bg-orange-600 text-white px-6 py-3 rounded-lg hover:bg-orange-700 transition-colors font-medium flex items-center gap-2"
                                        >
                                            <FaPlay className="text-sm" />
                                            Continue Test
                                        </button>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </div>

            {/* Footer */}
            <footer className="bg-[#2148C0] text-white py-6 mt-12">
                <div className="max-w-6xl mx-auto px-6 text-center">
                    <p className="text-blue-100">
                        &copy; {new Date().getFullYear()} TeeChaa CBT Application. All rights reserved.
                    </p>
                </div>
            </footer>
        </div>

    );
};

export default SingleSubjectQuizFree;